"use strict";

exports.__esModule = true;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_TIMEOUT = 50;

/**
A component for configurable skip loading.
@examples
```jsx
<AboveTheFoldOnlyServerRender skip={true}>
  <Footer />
</AboveTheFoldOnlyServerRender>
```
@component AboveTheFoldOnlyServerRender
@import {AboveTheFoldOnlyServerRender}
@playground
AboveTheFoldOnlyServerRender
```
<AboveTheFoldOnlyServerRender skip={true}>
  <Footer />
</AboveTheFoldOnlyServerRender>
```
@returns {ReactElement} The rendered component
*/

/* global clearTimeout, setTimeout */

var AboveTheFoldOnlyServerRender = function (_Component) {
  (0, _inherits3.default)(AboveTheFoldOnlyServerRender, _Component);

  function AboveTheFoldOnlyServerRender(props, context) {
    (0, _classCallCheck3.default)(this, AboveTheFoldOnlyServerRender);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));

    if (props.skip) {
      _this.state = { visible: false };
    } else {
      _this.state = { visible: !(0, _get2.default)(context, props.contextKey, false) };
    }

    _this._onShow = _this._onShow.bind(_this);
    return _this;
  }

  AboveTheFoldOnlyServerRender.prototype.componentDidMount = function componentDidMount() {
    if (!this.state.visible) {
      this.timeout = setTimeout(this._onShow, SHOW_TIMEOUT);
    }
  };

  AboveTheFoldOnlyServerRender.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }
  };

  AboveTheFoldOnlyServerRender.prototype._onShow = function _onShow() {
    this.setState({ visible: true });
  };

  AboveTheFoldOnlyServerRender.prototype.render = function render() {
    if (this.state.visible) {
      return this.props.children;
    }

    var _props = this.props,
        placeholder = _props.placeholder,
        placeholderClassName = _props.placeholderClassName,
        placeholderStyle = _props.placeholderStyle;


    return placeholder || _react2.default.createElement("div", { className: placeholderClassName, style: placeholderStyle });
  };

  return AboveTheFoldOnlyServerRender;
}(_react.Component);

AboveTheFoldOnlyServerRender.propTypes = {
  /**
  Children to render when visible
  */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),

  /**
  Tell AboveTheFoldOnlyServerRender to read context in order to skip server side rendering
  */
  contextKey: _propTypes2.default.string,

  /**
  Pass in another element to render when skipping server side rendering
  */
  placeholder: _propTypes2.default.element,

  /**
  Sets the className of the default placeholder
  */
  placeholderClassName: _propTypes2.default.string,

  /**
  Sets the style of the default placeholder
  */
  placeholderStyle: _propTypes2.default.object,

  /**
  Tell AboveTheFoldOnlyServerRender to skip server side rendering
  */
  skip: _propTypes2.default.bool
};

AboveTheFoldOnlyServerRender.contextTypes = {
  aboveTheFoldOnlyServerRender: _propTypes2.default.object
};

AboveTheFoldOnlyServerRender.defaultProps = {
  skip: false
};

exports.default = AboveTheFoldOnlyServerRender;